import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeedbackApiBase } from './feedback-api-base';
import { SignedUrlRequest, SuccessEnvelope, UploadFilesResult } from '../models';

/**
 * Mirrors App\Http\Controllers\FilesController.
 * All endpoints live under `/api/v1`.
 */
@Injectable({ providedIn: 'root' })
export class FilesService extends FeedbackApiBase {
  /** POST /v1/files — multipart upload of one or more files. */
  uploadFiles(files: File[], feedbackRoundId: string): Observable<UploadFilesResult> {
    const formData = new FormData();
    formData.append('feedbackRoundId', feedbackRoundId);
    for (const file of files) {
      formData.append('files[]', file, file.name);
    }
    return this.http
      .post<SuccessEnvelope<UploadFilesResult>>(this.url('files'), formData)
      .pipe(map((response) => response.data));
  }

  /** POST /v1/files/signed-url — resolves to the presigned upload URL. */
  getSignedUrl(request: SignedUrlRequest): Observable<string> {
    return this.http
      .post<SuccessEnvelope<{ url: string }>>(this.url('files/signed-url'), request)
      .pipe(map((response) => response.data.url));
  }
}
